export default "__VITE_ASSET__BnYwDkUv__"